/**
 * Session Manager
 * Handles session lifecycle (finish button, thank you screen)
 */

// Session state
let currentSessionId = null;

// Backend is proxied through Vite (/api → http://localhost:3001)
const BACKEND_URL = '';

/**
 * Initialize finish session button
 */
export function initializeFinishButton() {
  const finishButton = document.getElementById('finishSessionButton');
  if (!finishButton) return;

  finishButton.addEventListener('click', async () => {
    const confirmed = confirm('Ready to finish talking with Amal?');
    if (confirmed) {
      await endSession();
    }
  });
}

/**
 * End the current session
 */
async function endSession() {
  console.log('[SessionManager] Ending session:', currentSessionId);

  // Fire custom event to notify main.js to disconnect D-ID
  const event = new CustomEvent('sessionEnding');
  document.dispatchEvent(event);
  console.log('[SessionManager] sessionEnding event dispatched');

  // If we have a session ID, call the backend
  if (currentSessionId) {
    try {
      const token = sessionStorage.getItem('childToken');
      const endHeaders = {};
      if (token) endHeaders['Authorization'] = `Bearer ${token}`;
      await fetch(`${BACKEND_URL}/api/companion/session/${currentSessionId}/end`, {
        method: 'POST',
        headers: endHeaders
      });
      console.log('[SessionManager] Backend session ended:', currentSessionId);
    } catch (error) {
      console.error('[SessionManager] Error ending session:', error);
    }
  }

  // Show thank you screen
  showThankYouScreen();
}

/**
 * Show thank you screen after session ends
 */
function showThankYouScreen() {
  const container = document.getElementById('container');
  const thankYouScreen = document.getElementById('thankYouScreen');

  // Hide companion
  container.style.opacity = '0';
  container.style.transition = 'opacity 0.3s ease';

  setTimeout(() => {
    container.style.display = 'none';
    container.style.opacity = '1';

    // Show thank you
    thankYouScreen.style.display = 'flex';
  }, 300);

  // Clear session data
  currentSessionId = null;
  sessionStorage.removeItem('sessionId');
}

/**
 * Initialize start new session button on thank you screen
 */
export function initializeStartNewButton() {
  const startNewButton = document.getElementById('startNewSessionButton');
  if (!startNewButton) return;

  startNewButton.addEventListener('click', () => {
    console.log('[SessionManager] Start new session clicked');
    // Clear all session storage
    sessionStorage.clear();
    console.log('[SessionManager] Session storage cleared, reloading...');
    // Reload the page to start fresh
    window.location.reload();
  });
}

/**
 * Set the current session ID (called after backend creates session)
 * @param {string} sessionId
 */
export function setSessionId(sessionId) {
  currentSessionId = sessionId;
  sessionStorage.setItem('sessionId', sessionId);
}

/**
 * Get the current session ID
 * @returns {string|null}
 */
export function getSessionId() {
  return currentSessionId;
}
